import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectService} from '../project.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';
import {GenericModalComponent} from '../../modal/generic-modal.component';

@Component({

  selector: 'send-test-email-dialog',
  styles: [
      `
      .modal-dialog {
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      .modal-body {
        height: 150px;
        background-color:#ECE8E5;
      }

      .modal-header {
        height:56px;
      //background-color: #0064FE;
        background-image: url("../../../assets/images/headerBack.jpg");
        color:  #ECE8E5;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      .modal-content {
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
        background-color: #0064FE;
        padding-left: 3px;
        padding-right: 3px;
        padding-bottom: 3px;
      }
      .modal-footer{
        border-top:groove;
        background-color:#ECE8E5;
      }

      .ContentSection {
        padding-left: 20px;
      }

      .sectionTitle {
        font-size: large;
        font-weight: bold;
      }

      .mainTable {
        margin-left: 20px;
      }

      .borderGray {
        border: 1px solid #ccc;
      }

      .collapse {
        border: 2px solid slategray;
      }

      #btnRemoveAccordion {
        float: right;
      }

      .borderRed {
        border: 1px solid red;
      }

      .mainTable {
        width: 100%;
      }

      .twitterTable {
        margin-left: 20px;
      }

      .downloadSection {
        margin-left: 20px;
      }

      .facebookTable {
        margin-left: 20px;
      }

      .btn.btn-success {
        color: #ffffff;
        background-color: #5CB85C;
        background-image: linear-gradient(to bottom, #5CB85C, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }

      .btn.btn-success:hover {
        color: #ffffff;
        background-color: #419641;
        background-image: linear-gradient(to bottom, #419641, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }
      input.form-control{width:60%;display: table-cell}
      input[type="email"]:valid {
        color: green;
      }

      input[type="email"]:valid ~ .input-validation::before {
        content: "✓";
        color: green;
        display: table-cell;
      }

      input[type="email"]:invalid {
        color: red;
      }
      .child-float-left{float: left;}
      .emailControl{width:250px;}
      .mailWindow{height:40px; margin-top: -5px;}

      .modal-title{margin-left:15px;}

      .modalBodyContainer{
        background-color:  #ECE8E5;
      }

      .closeX{color:azure;size:25px;}
      .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
      }
      .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

      .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
      .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
      .btn-danger:hover{background-color: #FF2400;}
    `
  ],
  template: `
    <div class="modal" tabindex="-1" role="dialog" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <!-- header-->
          <div class="modal-header">
            <h4><img class="mailWindow" src="../../../assets/images/outlookIcon.png"></h4>
            <h4 class="modal-title" id="exampleModalLabel">Send Test Email</h4>
            <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
              <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
            </button></h4>
          </div>
          <div class="modalBodyContainer">
          <div class="modal-body">
            <!-- Texts -->
            <p>Select your language to push an Email.</p>
            <div>
              <select [(ngModel)]="this.selectedLanguage">
                <option *ngFor="let lang of langArr" [value]="lang">
                  {{lang}}
                </option>
              </select>
            </div>
            <div class="row" style="margin-left:1px;margin-top:20px;">
              <form [formGroup]=this.emailForm>
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">To</span>
                    </div>
                    <input type="email" formControlName="emailAddr" class="form-control emailControl" name="number"
                           pattern="\\w+@\\w+.\\w{2,3}" required/>
                  <div style="padding-left:10px;" class="child-float-left input-validation "></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- footer-->
          <div class="modal-footer ">
            <button type="button" (click)="onSmsTestEmail(this.emailForm['controls'].emailAddr.value)" class="btn btn-primary clickable hand" id="submit"><span
              class="glyphicon glyphicon-floppy-disk"></span> {{'send' | translate}}
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
    <generic-info-modal [hide]="_hideInfoModal" (OkClick)="hideDialog()"></generic-info-modal>
  `
})

export class SendTestEmailComponent  implements OnInit {

  private emailForm:FormGroup;

  private _hideInfoModal =true;

  private selectedLanguage:string;

  @Output() TestSendEmail: EventEmitter<any> = new EventEmitter();
  @Output() CloseEmailTest: EventEmitter<any> = new EventEmitter();

  @Input('terminal') terminal:Terminal;
  @Input('questionnaire') questionnaire:Questionnaire;
  @Input('langArr')  langArr:string[];
  @Input('path') emailConfigPath:string;

  @ViewChild (GenericModalComponent) genericModal: GenericModalComponent;

  @Input() hide = true;

  constructor(private _projectService: ProjectService, private _formBuilder:FormBuilder) {

  }

  ngOnInit(): void {
    this.emailForm = this._formBuilder.group({
      emailAddr: ['', Validators.minLength(10)]
    });
  }

  /*onSendTestClick() {
    this.TestSendEmail.emit(this.emailForm['controls'].emailAddr.value);
  }*/

  public onSmsTestEmail(emailAddr:string) {
    if(this.selectedLanguage==null || this.selectedLanguage==='') {
      this.genericModal.defineModal('Please select a language before pushing an Email.','Email Test',250);
      this._hideInfoModal = false;
      return;
    }
    this._projectService.sendEmail(this.questionnaire.projectId, this.questionnaire.id,this.terminal.id,this.terminal.type==='Android'?2:1,emailAddr,this.selectedLanguage,null,this.emailConfigPath).subscribe(
        (msg) => {
          if(msg === 100) {
            this.genericModal.defineModal('Test Email sent successfully !','Terminal Node',200);
          } else if(msg === 102) {
            this.genericModal.defineModal('An error has occurred while pushing email! Make sure you have defined an email before test sending it.','Terminal Node',msg);
          }
          this._hideInfoModal = false;
        });
  }

  hideDialog() {
    if(!this._hideInfoModal) {
      this._hideInfoModal = true;
    }
    this.hide = true;
    this.CloseEmailTest.emit(); // TODO: not useful anymore; remove it once confirmed
  }

  toggle() {
    this.hide = !this.hide;
  }

}
